import React from "react"
import ReportBilancio from "./Report"

const ReportPage = ({ match }) => {
  return (
    <ReportBilancio bilancioId={match.params.id} className="print" />
  )
}

export default ReportPage